import script from "./ProjectAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAddWorkerDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAddWorkerDropdown.vue?vue&type=style&index=0&id=0d5c92e4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5c92e4"]])

export default __exports__